export const originCountryToChinaList = ["AU", "IN", "IT", "MX", "ES", "US"];
export const HASH_STEP_PARAM = "qaq-step";
export const COPY_ID_PREFIX = "SpotShipmentPage";
export const COPY_ID_PREFIX_STEPPER = "Stepper";
export const COPY_ID_PREFIX_SHIPMENT_SUMMARY = "ShipmentSummary";
export const stepMap = {
  1: "TradeLane",
  2: "ShipmentLane",
  3: "OffersLane",
};

export const ariaDescription = {
  1: "Please choose business or private tab and enter your shipment destination",
  2: "Enter you item's weight and dimensions or add multiple items",
  3: "Review your delivery options and book now",
};
